import { render, staticRenderFns } from "./FloorsWithoutDrawings.vue?vue&type=template&id=1f793385&"
import script from "./FloorsWithoutDrawings.vue?vue&type=script&lang=ts&"
export * from "./FloorsWithoutDrawings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports